module.exports = __webpack_public_path__ + "img/887-de57c8.png";